import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export const useJSWorker = () => {
  const $ = _c(4);
  const [worker, setWorker] = useState(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const worker_0 = new Worker(new URL("src/features/codeRunner/lib/workers/codeExec.worker.ts", import.meta.url));
      setWorker(worker_0);
      return () => {
        worker_0.terminate();
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== worker) {
    t2 = {
      worker
    };
    $[2] = worker;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};